import React from 'react';

const SelectInput = ({
  label,
  name,
  id,
  value,
  onChange,
  options,
  required = false,
  disabled = false,
  className = '',
  error,
}) => {
  const baseClasses = "shadow appearance-none border rounded w-full py-2 px-3 bg-gray-700 text-text-white leading-tight focus:outline-none focus:shadow-outline";
  const errorClasses = error ? "border-red-500" : "border-border-subtle";

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2" htmlFor={id}>
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${baseClasses} ${errorClasses} ${className}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default SelectInput;